import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=6d13ff66&"
import script from "./Button.ts?vue&type=script&lang=ts&"
export * from "./Button.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports